import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { useOrganization, useDeviceDetect } from 'hooks';
import { HtmlRender } from 'components/elements';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function OnHoldMessage({ oid }) {
  const classes = useStyles();
  const { isMobile } = useDeviceDetect();
  const { t, i18n } = useTranslation('labels');
  const { data: organization } = useOrganization(oid);

  return (
    <div data-testid="on-hold-message" className={classes.onHoldMessageWrapper}>
      <div className={classes.onHoldMessage}>
        <img className={classes.logo} src={organization?.logoSmallUrl} alt="Logo Icon" />
        {isMobile ? (
          <Typography className={classes.onHoldMobileMessage} variant="body1" component="span" noWrap>
            {t('on_hold')}
          </Typography>
        ) : (
          <Typography variant="h5" component="h5">
            <HtmlRender
              data={organization?.onHoldMessageTranslations ? organization?.onHoldMessageTranslations[i18n.language] : organization?.videoSessionOnHoldMessage}
              htmlProfile
            />
          </Typography>
        )}
      </div>
    </div>
  );
}

OnHoldMessage.propTypes = {
  oid: PropTypes.string.isRequired,
};

export default OnHoldMessage;
